import type { QueryObject } from '@/shared/lib/serializeQuery';
import type { SearchCriteriaParams } from '@/shared/model';
import { toIds } from './values';

export function hotels(query: QueryObject): Pick<SearchCriteriaParams, 'hotels'> | null {
  const ids = toIds(query.hotels);

  return ids.length ? { hotels: ids } : null;
}
